// frontend/src/components/common/ReportModal.js
import React, { useState } from 'react';
import { FaExclamationTriangle, FaTimes, FaSpinner, FaCheckCircle } from 'react-icons/fa';
import { supportApi } from '../../api/support';

const REPORT_REASONS = [
    "Fraudulent Listing",
    "Incorrect Price",
    "Duplicate Listing",
    "Item Sold / Unavailable",
    "Wrong Category",
    "Offensive Content",
    "Other"
];

function ReportModal({ isOpen, onClose, itemId, itemName, itemType }) {
    const [reason, setReason] = useState(REPORT_REASONS[0]);
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await supportApi.reportListing({
                item_id: itemId,
                item_name: itemName,
                item_type: itemType,
                reason: reason,
                description: description
            });
            setSuccess(true);
            setTimeout(() => {
                onClose();
                setSuccess(false);
                setDescription('');
                setReason(REPORT_REASONS[0]);
            }, 2000);
        } catch (err) {
            alert("Failed to submit report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60 p-4 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-md overflow-hidden animate-fadeInUp">
                
                {/* Header */}
                <div className="bg-red-50 p-4 border-b border-red-100 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-red-700 flex items-center gap-2">
                        <FaExclamationTriangle /> Report Listing
                    </h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <FaTimes />
                    </button>
                </div>

                {success ? (
                    <div className="p-8 text-center">
                        <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                        <h4 className="text-xl font-bold text-gray-800">Report Submitted</h4>
                        <p className="text-gray-600 mt-2">Thank you for helping us keep the marketplace safe.</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-6 space-y-4">
                        <p className="text-sm text-gray-600">
                            You are reporting: <strong>{itemName}</strong>
                        </p>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Reason</label>
                            <select 
                                value={reason} 
                                onChange={(e) => setReason(e.target.value)}
                                className="w-full p-2 border rounded bg-white focus:ring-2 focus:ring-red-500 outline-none"
                            >
                                {REPORT_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
                            </select>
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Details (Optional)</label>
                            <textarea 
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                className="w-full p-2 border rounded focus:ring-2 focus:ring-red-500 outline-none"
                                rows="3"
                                placeholder="Please provide more details..."
                            ></textarea>
                        </div>

                        <div className="flex justify-end gap-3 pt-2">
                            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded">Cancel</button>
                            <button 
                                type="submit" 
                                disabled={loading}
                                className="px-4 py-2 bg-red-600 text-white font-bold rounded hover:bg-red-700 flex items-center gap-2"
                            >
                                {loading ? <FaSpinner className="animate-spin" /> : "Submit Report"}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ReportModal;